module.exports = __webpack_public_path__ + "static/media/ic_package_scan.192e2bd2.png";